import React from 'react';

const DownloadSVG = () => (
  <svg
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.97147 0.000161171V6.39875L9.3419 4.02833L10.225 4.91143L6.35176 8.78467L2.47852 4.91143L3.36161 4.02833L5.73204 6.39875V0.000161171H6.97147Z"
      fill="currentColor"
    />
    <path
      d="M2.15352 11.0001H10.5507C11.7437 11.0001 12.7042 10.0395 12.7042 8.84657V3.56348H11.4648V8.84657C11.4648 9.35784 11.0465 9.76066 10.5507 9.76066H2.15352C1.64225 9.76066 1.23944 9.34235 1.23944 8.84657V3.56348H0V8.84657C0 10.0395 0.960563 11.0001 2.15352 11.0001Z"
      fill="currentColor"
    />
  </svg>
);

export default DownloadSVG;
